// ----------------------------------------------------------------------
// <copyright file="Izenda.AuthUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import AccountConstants from 'logic/data/Izenda.AccountConstants';
import Cookies from 'js-cookie';
import AppGlobal from 'Izenda.AppGlobal';
import { forEach, isNil } from 'lodash/fp';

/**
 * Remove cookies
 * @param {Array}
 */
const removeCookies = (values) => {
  forEach((item) => {
    Cookies.remove(item.key, item.options);
  }, values);
}

const AuthUtils = {
  /**
     * Get cookie
     * @param {String} key
     * @returns {Object} Cookie
     */
  getCookie(key) {
    return Cookies.get(key);
  },

  /**
   * Set cookie
   * @param {String} key
   * @param {Object} value
   * @param {Object} option
   */
  setCookie(key, value, options) {
    isNil(options) ? Cookies.set(key, value) : Cookies.set(key, value, options);
  },

  /**
   * Remove cookie.
   * @param  {String} key
   * @param  {Object} options
   */
  removeCookie(key, options) {
    Cookies.remove(key, options);
  },

  /**
   * Update set of cookies
   * @param {Array}
   */
  updateCookies(values) {
    forEach((item) => {
      Cookies.set(item.key, item.value, item.options);
    }, values);
  },

  /**
   * Remove set of cookies
   * @param {Array}
   */
  removeCookies(values) {
    removeCookies(values);
  },

  /**
   * Remove auth cookies
   * @param {Array}
   */
  removeAuthCookies() {
    removeCookies([
      { key: AccountConstants.HEADER_KEYS.access_token },
      { key: AccountConstants.HEADER_KEYS.selected_tenant }
    ]);
  },

  /**
   * Get current token
   * @returns {Object} token
   */
  getAccessToken() {
    if (!isNil(AppGlobal.currentUserContext.token)) {
      return AppGlobal.currentUserContext.token;
    } else {
      const currentAccesstToken = this.getCookie(AccountConstants.HEADER_KEYS.access_token);
      if (!isNil(currentAccesstToken)) {
        return currentAccesstToken;
      }
    }
    return null;
  },

  /**
   * Set access token
   * @param {String} token
   */
  setAccessToken(token) {
    this.setCookie(AccountConstants.HEADER_KEYS.access_token, token);
  },

  /**
   * Get tenant ID from cookie
   * @param {String} selectedTenant
   */
  getSelectedTenant() {
    return this.getCookie(AccountConstants.HEADER_KEYS.selected_tenant);
  },

  /**
   * Set tenant ID to cookie
   * @param {String} selectedTenant
   */
  setSelectedTenant(selectedTenant) {
    this.setCookie(AccountConstants.HEADER_KEYS.selected_tenant, selectedTenant);
  },

  /**
   * Remove tenant ID in cookie
   * @param {String} selectedTenant
   */
  removeSelectedTenant() {
    this.removeCookie(AccountConstants.HEADER_KEYS.selected_tenant);
  }
};
export default AuthUtils;



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.AuthUtils.js